<template>
	<footer>
		<div class="footer-element">
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h3>{{ $t('contact') }}</h3>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
							<font-awesome-icon icon="fa-light fa-phone" size="1x" />
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<br />
						<a :href="`mailto:${defaults[locale].website.email}`">
							<font-awesome-icon icon="fa-light fa-envelope" size="1x" />
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h3>{{ defaults[locale].website.hotelName }}</h3>
					<p>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span
						><br />
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span
						><br />
						<span>{{ defaults[locale].website.country }}</span
						><br />
					</p>
				</div>
				<div class="columns column3">
					<h3>{{ $t('footerNavigate') }}</h3>
					<p class="footer-nav">
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }} <br />
						</nuxt-link>
					</p>
				</div>
			</div>
			<div class="row">
				<div class="columns column12">
					<hr />
				</div>
			</div>
		</div>
		<div class="footer-element author">
			<div class="row">
				<div class="columns column12 align-center">
					<p class="align-left">
						<span style="margin: 0 20px 0 0">
							<a :href="$t('siteByUrl')" target="_blank" rel="noopener noreferrer">
								Hotel Website Design
							</a>
							by:
							<a :href="$t('siteByUrl')" target="_blank">
								<img class="siteByLogo" :src="$t('siteByLogo')" loading="lazy" alt="Site by" />
								Porter
							</a>
						</span>
						<span>
							<a href="https://www.eclect.com/" target="_blank" rel="noopener noreferrer">
								<img
									src="~/assets/images/logo-eclect.png"
									class="eclect-logo"
									style="margin-right: 10px"
								/>
								<span>{{ $t('eclectTag') }}</span>
							</a>
						</span>
					</p>
					<p class="align-right">
						<span v-for="(item, idx) in bottomfooter[locale]" :key="item.filename">
							<nuxt-link :to="item.filename">
								{{ item.header }}
							</nuxt-link>
							<span v-if="idx < bottomfooter[locale].length - 1">|</span>
						</span>
						<span v-if="defaults[locale].cookieConsent.published">
							<span> | </span>
							<a href="#" @click.prevent="openConsent">{{ $t('consentOpen') }}</a>
						</span>
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu, bottomfooter } = footer.value;
const { locale } = useI18n();
const { openConsent } = useCookieConsent();

const { defaults, socials, fetchDefaults } = useDefaults();

await fetchDefaults();
</script>

<style lang="scss" scoped>
.footer-element {
	background: var(--footer-background-color);
	color: var(--footer-color);
	padding: 75px 0 10px;
}

.footer-element hr {
	background: #f6efd3;
}

.footer-element a {
	color: var(--footer-color);

	&:hover {
		color: var(--cta-color);
	}

	svg {
		margin: 0 20px 0 0;
	}
}

.footer-element h3 {
	color: #f6efd3;
	text-transform: uppercase;
	font-size: 20px;
}

.footer-element.author {
	padding: 10px 0;
	font-size: 12px;
}

.author .column12 {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-between;
	padding: 0 20px;
}

.author img {
	max-width: 20px;
	margin: 0 1px 0 2px;
}

.footer-logo {
	background: url('~/assets/images/logo-hotelkint-full.png') no-repeat center center;
	background-size: 149px;
	width: 149px;
	height: 86px;
	margin: 0;
}

.socials a {
	color: #fff;
	background: none;
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 22px;
	margin: 5px 5px 5px 0;
	text-decoration: none;
}

.socials a:hover {
	color: #fff;
	background: var(--cta-color-hover);
}

@media (max-width: 920px) {
	.footer-element .columns {
		margin: 20px auto;
	}

	.author .columns {
		margin: 0;
		flex-flow: wrap column-reverse;
	}

	.author p {
		width: 100%;
		margin: 0 0 5px;
		text-align: center;
	}
}

@media (max-width: 680px) {
	.footer-element {
		text-align: center;
	}

	.footer-logo {
		margin: 0 auto;
	}
}
</style>
